"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAction = exports.InternalDataSiloObjectResolver = exports.RequestActionObjectResolver = exports.REQUEST_ACTION_OPT_IN_TO_OPT_OUT = exports.REQUEST_ACTION_OPT_OUT_TO_OPT_IN = exports.RequestActionOptIn = exports.RequestActionOptOut = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * The type of requests that allow for opt-out
 */
exports.RequestActionOptOut = (0, type_utils_1.makeEnum)({
    /** Opt out of automated decision making */
    AutomatedDecisionMakingOptOut: 'AUTOMATED_DECISION_MAKING_OPT_OUT',
    /** Ability to opt out of the use of sensitive information. A requirement under the CPRA and similar laws. */
    UseOfSensitiveInformationOptOut: 'USE_OF_SENSITIVE_INFORMATION_OPT_OUT',
    /** Opt out of all communication */
    ContactOptOut: 'CONTACT_OPT_OUT',
    /** Opt-out of the sale of personal data */
    SaleOptOut: 'SALE_OPT_OUT',
    /** Opt out of tracking */
    TrackingOptOut: 'TRACKING_OPT_OUT',
    /** Opt out custom */
    CustomOptOut: 'CUSTOM_OPT_OUT',
});
/**
 * The type of requests that allow for opt-in
 */
exports.RequestActionOptIn = (0, type_utils_1.makeEnum)({
    /** Opt in to automated decision making */
    AutomatedDecisionMakingOptIn: 'AUTOMATED_DECISION_MAKING_OPT_IN',
    /** Ability to opt in to the use of sensitive information. A requirement under the CPRA and similar laws. */
    UseOfSensitiveInformationOptIn: 'USE_OF_SENSITIVE_INFORMATION_OPT_IN',
    /** Opt-in to the sale of personal data */
    SaleOptIn: 'SALE_OPT_IN',
    /** Opt in to tracking */
    TrackingOptIn: 'TRACKING_OPT_IN',
    /** Opt in to contact */
    ContactOptIn: 'CONTACT_OPT_IN',
    /** Opt in custom */
    CustomOptIn: 'CUSTOM_OPT_IN',
});
/**
 * Mapping between request actions that are inverses
 * of one another.
 */
exports.REQUEST_ACTION_OPT_OUT_TO_OPT_IN = {
    [exports.RequestActionOptOut.AutomatedDecisionMakingOptOut]: exports.RequestActionOptIn.AutomatedDecisionMakingOptIn,
    [exports.RequestActionOptOut.UseOfSensitiveInformationOptOut]: exports.RequestActionOptIn.UseOfSensitiveInformationOptIn,
    [exports.RequestActionOptOut.ContactOptOut]: exports.RequestActionOptIn.ContactOptIn,
    [exports.RequestActionOptOut.TrackingOptOut]: exports.RequestActionOptIn.TrackingOptIn,
    [exports.RequestActionOptOut.SaleOptOut]: exports.RequestActionOptIn.SaleOptIn,
    [exports.RequestActionOptOut.CustomOptOut]: exports.RequestActionOptIn.CustomOptIn,
};
exports.REQUEST_ACTION_OPT_IN_TO_OPT_OUT = (0, type_utils_1.invert)(exports.REQUEST_ACTION_OPT_OUT_TO_OPT_IN);
/**
 * An request action resolve types that can be run at the object level
 */
exports.RequestActionObjectResolver = (0, type_utils_1.makeEnum)({
    /** Data Download request */
    Access: 'ACCESS',
    /** Erase the file completely */
    Erasure: 'ERASURE',
    /** Make an update to an inaccurate record */
    Rectification: 'RECTIFICATION',
    /** A restriction of processing request */
    Restriction: 'RESTRICTION',
    /** Business Purpose Report */
    BusinessPurpose: 'BUSINESS_PURPOSE',
    /** Add user to a legal hold */
    PlaceOnLegalHold: 'PLACE_ON_LEGAL_HOLD',
    /** Remove a user from a legal hold */
    RemoveFromLegalHold: 'REMOVE_FROM_LEGAL_HOLD',
    ...exports.RequestActionOptOut,
    ...exports.RequestActionOptIn,
});
/**
 * The privacy actions that can be set at the object level for a
 * data silo configured as webhook or cron integration.
 *
 * Privacy actions are specified globally and logic is left to the
 * webhook service to implement. The individual objects can still be
 * labeled for whether they should be included in data access requests.
 */
exports.InternalDataSiloObjectResolver = (0, type_utils_1.makeEnum)({
    /** Data Download request */
    Access: 'ACCESS',
});
/**
 * The types of requests that Data Subject can make
 */
exports.RequestAction = (0, type_utils_1.makeEnum)({
    ...exports.RequestActionOptOut,
    ...exports.RequestActionOptIn,
    /** Data Download request */
    Access: 'ACCESS',
    /** Erase the profile from the system */
    Erasure: 'ERASURE',
    /** Make an update to an inaccurate record */
    Rectification: 'RECTIFICATION',
    /** Restrict processing */
    Restriction: 'RESTRICTION',
    /** Business Purpose Report */
    BusinessPurpose: 'BUSINESS_PURPOSE',
    /** Add user to a legal hold */
    PlaceOnLegalHold: 'PLACE_ON_LEGAL_HOLD',
    /** Remove a user from a legal hold */
    RemoveFromLegalHold: 'REMOVE_FROM_LEGAL_HOLD',
});
//# sourceMappingURL=actions.js.map